export default __webpack_public_path__ + "static/media/learose5-768w.6cbfa74d.webp";